import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAllStaffMembers = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["allStaffMembers", tenantVal],
    queryFn: async () => {
      if (!tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/staffmember`);
      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching staff members" },
  });
};
